import * as React from 'react';
import { useTheme } from 'styled-components';

import appUrls from 'base/app/urls';
import { BUTTON_VARIANTS, TITLE_VARIANTS } from 'common/consts';
import { Arrow } from 'common/icons';
import { Button, Link, Title } from 'common/components';
import {
  ItemsContainer,
  TitleContainer,
  TopBarContainer,
  TopBarContent,
} from 'common/components/TopBar';

import RecipeSubsection from './RecipeSubsection';
import { RECIPE_SUBSECTIONS } from '../consts';

export interface TopBarProps {
  disableNav?: boolean;
  children?: React.ReactNode;
  subsection?: RECIPE_SUBSECTIONS;
}

const RecipeTopBar = ({ disableNav, children, subsection }: TopBarProps) => {
  const theme = useTheme();
  const isMainSubsection = !subsection || subsection === RECIPE_SUBSECTIONS.MAIN;
  const arrowLink = isMainSubsection ? appUrls.DASHBOARD : appUrls.RECIPES.LIST;

  return (
    <TopBarContainer>
      <TopBarContent>
        <ItemsContainer>
          {!disableNav && (
            <Button variant={BUTTON_VARIANTS.ICON} as={Link} to={arrowLink}>
              <Arrow
                $color={theme.keys.secondaryColor}
                $width="3px"
                $size="12px"
                $margin={[0.5]}
              />
            </Button>
          )}
          <TitleContainer>
            <Link to={appUrls.RECIPES.LIST}>
              <Title variant={TITLE_VARIANTS.HEADER}>Recipes</Title>
            </Link>
          </TitleContainer>
          <RecipeSubsection selected={subsection} />
        </ItemsContainer>
        <ItemsContainer>{children}</ItemsContainer>
      </TopBarContent>
    </TopBarContainer>
  );
};

export default RecipeTopBar;
